import React, { useEffect, useState } from 'react';
import '../styles/Projects.css';
import { collection, getDocs } from 'firebase/firestore';
import { database } from './firebase';
import { track } from '../lib/analytics';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [status, setStatus] = useState('loading'); // loading | ready | error

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setStatus('loading');
        const querySnapshot = await getDocs(collection(database, "projects"));
        const projectsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProjects(projectsData.sort((a, b) => a.order - b.order));
        setStatus('ready');
      } catch (error) {
        console.error("Error fetching projects:", error);
        setStatus('error');
      }
    };

    fetchProjects();
  }, []);

  return (
    <section id="projects" className="section section-card projects">
      <div className="section-head">
        <h2 className="section-title">Projects</h2>
        <p className="section-subtitle">Project highlights with concise, “scan-able” summaries.</p>
      </div>

      {status === 'loading' ? (
        <p className="section-muted">Loading projects…</p>
      ) : status === 'error' ? (
        <p className="section-muted">Could not load projects.</p>
      ) : projects.length === 0 ? (
        <p className="section-muted">No projects yet.</p>
      ) : (
        <div className="projects-grid">
          {projects.map((project, index) => (
            <article key={project.id} className="project-card">
              <div className="project-main">
                <h3 className="project-title">{project.name}</h3>
                <p className="project-desc">{project.description}</p>
              </div>

              {project.link ? (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                  onClick={() => {
                    track('project_visit_click', {
                      surface: 'projects_section',
                      section: 'projects',
                      project_id: project.id,
                      project_name: project.name,
                      project_url: project.link,
                      position: index,
                    });
                  }}
                >
                  Visit
                </a>
              ) : null}
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default Projects; 
